import moment from "moment";
import pl_locale from "moment/locale/pl";
import nl_locale from "moment/locale/nl";

export function mapCostBearerTypes(costType) {
  switch (costType) {
    case 1:
      return "Project Intern";
    case 2:
      return "Project External";
    case 3:
      return "Object";
    case 4:
      return "General";
    case 5:
      return "WorkSlip";
  }
}

export function formatDateServer(date) {
  return moment(date).format("YYYY-MM-DD[T]00:00:00");
}

export function formatDateTimeServer(date) {
  return moment(date).format("YYYY-MM-DD[T]HH:mm:00");
}
export function formatDateIsoTimeZone(date){
   var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
   var isoDateTime = (new Date(date - tzoffset)).toISOString().slice(0, -1);
   return isoDateTime;
}

export function getDateOfISOWeek(w, y) {
  var simple = new Date(y, 0, 1 + (w - 1) * 7);
  var dow = simple.getDay();
  var ISOweekStart = simple;
  if (dow <= 4) ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
  else ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
  return ISOweekStart;
}

export function getEmployeeLanguage(lang) {
  switch (lang) {
    case 1:
      return "nl";
    case 2:
      return "en";
    case 3:
      return "pl";
    default:
      return "en";
  }
}

export function setMomentLocale(lang) {
  switch (lang) {
    case "nl":
      moment.locale("nl", nl_locale);
      break;
    case "pl":
      moment.locale("pl", pl_locale);
      break;
    case "en":
      moment.locale("en");
      break;
    default:
      moment.locale();
  }
}

export function isTrailerWorkslip(workslipnumber){
  if (workslipnumber){
     var result = workslipnumber.endsWith('H') || 
                             workslipnumber.endsWith('T') || 
                            (workslipnumber.length == 14 && workslipnumber.substring(4, 5) === "3");
    return result; 
  }

  return false;   
}
